<template lang="pug">
  v-app-bar(app)
    v-toolbar-title.headline(text-uppercase)
      span ラボプレクス
      span.font-weight-light 売上伝票
    v-spacer
    v-btn(v-if="!isLogin"
      text
      href="/#/login"
    )
      span.mr-2 ログイン
    v-btn(v-if="isLogin"
      text
      v-on:click="to_menu"
    )
      span.mr-2 メインメニュー
    v-btn(v-if="isLogin"
      text
      v-on:click="logout"
    )
      span.mr-2 ログアウト
</template>

<script>
  import debugLog from '@/utils/debugLog'

  export default {
    name: 'Navbar',
    computed: {
      isLogin: function() { return this.$store.getters.isLogin }
    },
    methods: {
      logout: function() {
        debugLog('logout!')
        this.$store.dispatch('session/logout')
        this.$router.push('/')
      },
      to_menu: function() {
        this.$router.push('/sales_slip/menu')
      }
    }
  }
</script>
